const PLAN_COLOR = {
    PLUS: 'light-green-color',
    PRO: 'light-torques-color',
    ICONIC: 'orange-color',
    BASIC: 'light-green-color'
}

export {
    PLAN_COLOR
}